<div ngxUiLoaderBlurred>
    <router-outlet></router-outlet>
</div>

<ngx-ui-loader [hasProgressBar]='true'></ngx-ui-loader>